export const restUrlProducts = "/api/products";
export const restUrlContact = "/api/contact";
// export const restUrlProducts = "http://localhost:3800/api/products";
// export const restUrlContact = "http://localhost:3800/api/contact";
// export const sections = [
//     { title: "Technology", url: "#" },
//     { title: "Design", url: "#" },
//     { title: "Culture", url: "#" },
//     { title: "Business", url: "#" },
//     { title: "Politics", url: "#" },
//     { title: "Opinion", url: "#" },
//     { title: "Science", url: "#" },
//     { title: "Health", url: "#" },
//     { title: "Style", url: "#" },
//     { title: "Travel", url: "#" },
//   ];
export const getSections = (t) => [
  { title: t("products"), url: "/" },
  { title: t("contactUs"), url: "/contact" },
];
